import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';
import { LoaderService } from '../../common-explain/services/loader.service';
import { ApiCrmService } from './api/crm/api-crm.service';
import { ModalCrmIntegrationComponent } from '../../components/modal-crm-integration/modal-crm-integration.component';

@Injectable({ providedIn: 'root' })
export class CrmIntegrationModalService {
  private readonly ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    windowClass: 'modal-width-666',
  };

  constructor(
    private modalService: NgbModal,
    private loaderService: LoaderService,
    private apiCrm: ApiCrmService
  ) {}

  async open(crmType: 'hubspot' | 'salesforce') {
    try {
      this.loaderService.displayLoader(true);
      const authorizationUrl = await firstValueFrom(this.apiCrm.generateOauthLink({ crm_type: crmType }));

      const modalRef = this.modalService.open(ModalCrmIntegrationComponent, this.ngbModalOptions);
      modalRef.componentInstance.authorizationUrl = authorizationUrl;
      const childWindow: Window | null = await modalRef.result;
      return childWindow;
    } finally {
      this.loaderService.hideLoader(true);
    }
  }
}
